import React from 'react';

import LoanAmountInput from '../LoanAmountInput';

const LoanAmountInputPreload = props => {
  const { capOnLoan, ...otherProps } = props;
  const { maxLoanAmount } = capOnLoan;
  let loanAmountInput;

  if (!maxLoanAmount) {
    loanAmountInput = <p>Data loading...</p>;
  } else {
    loanAmountInput = <LoanAmountInput maxLoanAmount={maxLoanAmount} {...otherProps} />;
  }

  return loanAmountInput;
};

export default LoanAmountInputPreload;
